const reducer = (state = {}, action) => {
  switch (action.type) {
    case 'SET_BALANCE': {
      return {
        ...state,
        ...action.payload,
        showShimmer: false,
      };
    }
    case 'GET_BILL_DETAIL': {
      return {
        ...state,
        billDetails: {},
        showShimmer: true,
      };
    }
    case 'SET_BILL_DETAILS': {
      return {
        ...state,
        showShimmer: false,
        billDetails: action.data,
      };
    }
    case 'GET_BILL_TRANSACTION': {
      return {
        ...state,
        billTxnList: {},
        showShimmer: true,
      };
    }
    case 'SET_BILL_TRANSACTION': {
      return {
        ...state,
        billTxnList: action.data,
        showShimmer: false,
      };
    }
    case 'GET_BILL_PENALTIES': {
      return {
        ...state,
        billPenaltyList: {},
        showShimmer: true,
      };
    }
    case 'SET_BILL_PENALTIES': {
      return {
        ...state,
        billPenaltyList: action.data,
        showShimmer: false,
      };
    }
    case 'SET_CURRENT_BALANCE': {
      return {
        ...state,
        currentBalance: action.data,
        showShimmer: false,
      };
    }
    case 'SET_ACC_DETAILS': {
      return {
        ...state,
        verAccDetails: action.data,
        showShimmer: false,
      };
    }
    case 'PAYMENT_LIST': {
      return {
        ...state,
        showShimmer: true,
      };
    }
    case 'PREV_BALANCE': {
      return {
        ...state,
        showShimmer: true,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
